export const GithubRepoDecorator = data => ({
	githubAccountId: data.owner?.login?.toLowerCase(),
	githubRepoId: data.name?.toLowerCase(),
	subdirectory: data.subdirectory,
});

export const matchGithubRepo = (model, data) => {
	return model.github?.githubAccountId === data.githubAccountId && model.github?.githubRepoId === data.githubRepoId;
};
